import { LAUNCH_SELECTION_DISABLED_REASON } from '@aline/common/launch-fields/selection';

interface LaunchTemplatePrimaryDisabledReasonOptions {
  /** A checkbox field holds more or fewer choices than its limits allow. */
  hasSelectionError: boolean;
  isTemplatePublished: boolean;
  isWorkflowUntitled: boolean;
  loadingTemplateData: boolean;
  templateDataError: boolean;
  templateWorkflowId: UUID | null;
}

export function getLaunchTemplatePrimaryDisabledReason({
  hasSelectionError,
  isTemplatePublished,
  isWorkflowUntitled,
  loadingTemplateData,
  templateDataError,
  templateWorkflowId,
}: LaunchTemplatePrimaryDisabledReasonOptions) {
  if (!templateWorkflowId) return 'Select a template';
  if (loadingTemplateData) return 'Loading template...';
  if (templateDataError) return 'Unable to load template';
  if (!isTemplatePublished) return 'Publish template to launch';
  if (isWorkflowUntitled) return 'Give your workflow a name';
  if (hasSelectionError) return LAUNCH_SELECTION_DISABLED_REASON;
  return '';
}
